var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2287",
    "data-name": "Group 2287",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M0,0H26V26H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M3.083,3h19.5a1.083,1.083,0,0,1,1.083,1.083V21.417A1.083,1.083,0,0,1,22.583,22.5H3.083A1.083,1.083,0,0,1,2,21.417V4.083A1.083,1.083,0,0,1,3.083,3ZM21.5,11.667H4.167v8.667H21.5Zm0-2.167V5.167H4.167V9.5ZM15,16h4.333v2.167H15Z",
    transform: "translate(0.167 0.25)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.de06482862bdd675321eb70f54108644.svg";
export { ForwardRef as ReactComponent };